import { Link } from "react-router-dom";

// Advanced on the node page: every setting the server knows, what was asked
// for and what the node reports (read-only), and the tool pages for the rest:
// Node control (the full settings editor, live mode, firmware updates), Radar
// analysis, Radar lab and Field cameras. Nothing here sends anything.
const show = (v) => (v === undefined || v === null || v === "" ? "–" : String(v));

export default function AdvancedPanel({ settings }) {
  const keys = Array.isArray(settings?.allowed_keys) ? settings.allowed_keys : [];
  const desired = settings?.desired || {};
  const reported = settings?.reported || {};
  const differs = (k) => k in desired && show(desired[k]) !== show(reported[k]);
  return (
    <section className="field-panel" aria-label="Advanced">
      <div className="field-panel-head">
        <div>
          <h2>Advanced</h2>
          <p>All settings and tool pages</p>
        </div>
      </div>
      <div className="field-panel-body">
        <ul className="field-node-links">
          <li>
            <Link to="/node-control">Node control</Link>: every setting, live mode, firmware updates
          </li>
          <li>
            <Link to="/radar-analysis">Radar analysis</Link>: echoes, bursts, the radar profile, rain
          </li>
          <li>
            <Link to="/radar-lab">Radar lab</Link>: lab runs on the tank
          </li>
          <li>
            <Link to="/field-cameras">Field cameras</Link>: every capture
          </li>
        </ul>
        {keys.length > 0 && (
          <details>
            <summary>All settings ({keys.length}): requested and reported</summary>
            <div className="field-table-scroll">
              <table className="field-table" aria-label="All settings">
                <thead>
                  <tr>
                    <th>Setting</th>
                    <th>Asked for</th>
                    <th>Node</th>
                  </tr>
                </thead>
                <tbody>
                  {keys.map((k) => (
                    <tr key={k} className={differs(k) ? "is-highlighted" : ""}>
                      <td>{k}</td>
                      <td>{show(desired[k])}</td>
                      <td>{show(reported[k])}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </details>
        )}
      </div>
    </section>
  );
}
